import { Component } from '@angular/core';

@Component({
  selector: 'greco-agreement-temp',
  templateUrl: './agreement-temp.page.html',
  styleUrls: ['./agreement-temp.page.scss'],
})
export class AgreementTempPage {}
